import { Component } from '@angular/core';
import { PageH1Service } from './page-h1.service';

@Component({
  selector: 'app-page-h1',
  templateUrl: './page-h1.component.html',
  styleUrls: ['./page-h1.component.css'],
})
export class PageH1Component {
  constructor(public pageH1Service: PageH1Service) {}
}
